import React from 'react';
import { useTheme } from 'styled-components';
import { useActiveSubmenu } from '../../ActiveSubmenu/ActiveSubmenuProvider';
import { useS4AMastheadContext } from '../../S4AMastheadProvider';
import { trackCat } from '../constants';
import { NavText } from '../NavText';
export var SubmenuTrigger = function (_a) {
    var id = _a.id, label = _a.label;
    var _b = useActiveSubmenu(id), claimActiveSubmenu = _b.claimActiveSubmenu, isActiveSubmenu = _b.isActiveSubmenu;
    var InteractiveElement = useS4AMastheadContext().InteractiveElement;
    var theme = useTheme();
    return (React.createElement(InteractiveElement, { customComponent: NavText, className: isActiveSubmenu ? 'active' : '', id: id, size: "xsmall", color: theme.text, onHover: claimActiveSubmenu, trackingLabel: label, trackingCategory: trackCat, isFocus: isActiveSubmenu, onKeyDown: function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                claimActiveSubmenu();
            }
        }, label: label }));
};
